/**
 * actionsColumnWidth
 *
 * Shared calculated width for a grid's Actions column, so the header cell and every
 * body cell stay aligned regardless of how many action buttons a given list renders.
 * See `.github/context/list-grid-standard.context.md` §11.
 *
 * Apply the SAME computed value to the Actions header cell AND every body Actions cell.
 * e.g. actionsColumnWidth(1 + (canEdit ? 1 : 0) + (canDelete ? 1 : 0))
 *      1 button = '3rem', 3 buttons = '7rem'
 */
const SLOT_REM = 2; // one 32px Fluent icon button
const GAP_REM = 0.25; // spacingHorizontalXS between buttons
const PAD_REM = 1; // cell left + right padding

export function actionsColumnWidth(buttonCount: number): string {
  return `${buttonCount * SLOT_REM + Math.max(buttonCount - 1, 0) * GAP_REM + PAD_REM}rem`;
}
